import http from '@/utils/http' //引入axios
export const getErrorType = data => http.get('/maintenance-center/api/errortype', {
    params: data
}) //查找故障類型
export const updataErrorType = data => http.put('/maintenance-center/api/errortype', data) //編輯故障類型
export const addErrorType = data => http.post('/maintenance-center/api/errortype', data) //添加故障類型
export const deleteErrorType = data => http.delete('/maintenance-center/api/errortype', {
    params: data
}) //故障類型
export default {
    getErrorType,
    updataErrorType,
    addErrorType,
    deleteErrorType,
    // findBarcode
}